export default "__VITE_ASSET__DqStCEca__"